// -----------------------------------------------------------
// FloraIQ - Sources & Traceability (Aba 5: Fontes e Evidências)
// -----------------------------------------------------------

import { type FC } from "react";
import { ladmSources, rastreabilidadeQuestions } from "@/mocks/ladm";
import LadmStatusBadge from "./LadmStatusBadge";
import type { LadmBadgeVariant } from "./LadmStatusBadge";

const sourceStatusMap: Record<string, LadmBadgeVariant> = {
  validado: "validado",
  pendente_aprovacao: "pendente_aprovacao",
};

const SourcesTraceabilitySection: FC = () => {
  return (
    <div className="space-y-6">
      {/* Rastreabilidade */}
      <div className="bg-white rounded-card border border-background-200/70 p-5">
        <h3 className="text-sm font-semibold text-foreground-900 font-heading mb-4">Rastreabilidade da Informação</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {rastreabilidadeQuestions.map((item) => (
            <div key={item.question} className="p-3 rounded-lg border border-background-200/70 bg-background-50/50 hover:shadow-sm transition-shadow cursor-pointer">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-7 h-7 rounded-md bg-blue-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-blue-600 text-xs`}></i>
                </div>
                <span className="text-xs font-semibold text-foreground-700">{item.question}</span>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Tabela de Fontes */}
      <div className="bg-white rounded-card border border-background-200/70 overflow-hidden">
        <div className="px-4 py-3 border-b border-background-200/50">
          <h3 className="text-sm font-semibold text-foreground-900 font-heading">Matriz de Fontes</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100/70">
                <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 font-heading whitespace-nowrap">Fonte</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 font-heading whitespace-nowrap">Tipo</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 font-heading whitespace-nowrap">Unidade Vinculada</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 font-heading whitespace-nowrap">Informação Comprovada</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 font-heading whitespace-nowrap">Responsável</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 font-heading whitespace-nowrap">Data</th>
                <th className="text-center px-4 py-3 text-xs font-semibold text-foreground-600 font-heading whitespace-nowrap">Status</th>
                <th className="text-center px-4 py-3 text-xs font-semibold text-foreground-600 font-heading whitespace-nowrap">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-200/50">
              {ladmSources.map((src) => (
                <tr key={src.id} className="hover:bg-background-50/60 transition-colors">
                  <td className="px-4 py-2.5 text-xs font-medium text-foreground-900 max-w-[200px] truncate">{src.nome}</td>
                  <td className="px-4 py-2.5">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 font-medium whitespace-nowrap">{src.tipo}</span>
                  </td>
                  <td className="px-4 py-2.5 text-xs text-foreground-700 font-mono">{src.unidadeVinculada}</td>
                  <td className="px-4 py-2.5 text-xs text-foreground-600 max-w-[220px] truncate">{src.informacaoComprovada}</td>
                  <td className="px-4 py-2.5 text-xs text-foreground-700 whitespace-nowrap">{src.responsavel}</td>
                  <td className="px-4 py-2.5 text-xs text-foreground-500 whitespace-nowrap">{new Date(src.data + "T00:00:00").toLocaleDateString("pt-BR")}</td>
                  <td className="px-4 py-2.5 text-center">
                    <LadmStatusBadge variant={sourceStatusMap[src.status] || "validado"} />
                  </td>
                  <td className="px-4 py-2.5 text-center">
                    <button className="text-xs text-blue-600 hover:text-blue-700 cursor-pointer whitespace-nowrap">
                      <i className="ri-eye-line mr-1"></i>Ver
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SourcesTraceabilitySection;